<template>
  <v-container>
    <div class="elevation-2 px-5 mt-3">
      <SimplePageHeader title="Permanent Placement Goals" class="px-4 pr-5 mb-5"></SimplePageHeader>
      <v-row
        align="center"
        justify="start"
        class="px-5 mb-sm-5"
      >
        <v-col cols="6" sm="3" md="2">
          <v-text-field
            label="Year"
            v-model="selectedYear"
            validate-on-blur
            outlined
            :maxlength="4"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row justify="end">
        <v-col cols="12" sm="6">
          <FilterButtons
            @search="handleSearchClick"
            @clear="handleClearClick"
          ></FilterButtons>
        </v-col>
      </v-row>
      <FilterButtonsSmall
        @search="handleSearchClick"
        @clear="handleClearClick"
      ></FilterButtonsSmall>
    </div>
    <v-container fluid class="px-0 pt-2 mt-4">
      <v-card class="pt-3">
        <v-card-text>
          <v-row>
            <v-col cols="12">
              Enter Your Company Permanent Placement Goals in Dollars by Month.
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <DirectPlacementGoalInput
                :directPlacementGoals="directPlacementGoals"
                @directPlacementGoalChange="(newValue) => { this.directPlacementGoals = newValue }"
              ></DirectPlacementGoalInput>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>
    <ButtonsSubmitForm
      :is-form-valid="true"
      @save="handleSaveDirectPlacementGoals"
      @cancel="cancel"
    >
    </ButtonsSubmitForm>
    <BottomSpacer></BottomSpacer>
  </v-container>
</template>

<script>
import { SimplePageHeader } from '@/components/pageComponents'
import { FilterButtons, FilterButtonsSmall, BottomSpacer, ButtonsSubmitForm } from '@/components/buttons'
import DirectPlacementGoalInput from '@/components/directPlacements/DirectPlacementGoalsInput'
import { mapFields } from '@/vueHelpers/vuex'
import { mapActions } from 'vuex'
import { FormattedNumberField } from '@/components/shared/textFields'
import { dashboardRoute } from '@/lib/constants/routes'

export default {
  components: {
    SimplePageHeader,
    FilterButtons,
    FilterButtonsSmall,
    BottomSpacer,
    DirectPlacementGoalInput,
    ButtonsSubmitForm,
    FormattedNumberField
  },
  data () {
    return {
      selectedYear: new Date().getFullYear()
    }
  },
  methods: {
    ...mapActions('directPlacementGoals', ['getDirectPlacementGoals', 'saveDirectPlacementGoals']),
    handleSearchClick () {
      this.getDirectPlacementGoals(this.selectedYear)
    },
    handleClearClick () {
      this.selectedYear = new Date().getFullYear()
      this.getDirectPlacementGoals()
    },
    handleSaveDirectPlacementGoals () {
      this.saveDirectPlacementGoals(this.directPlacementGoals)
    },
    cancel () {
      this.$router.push(dashboardRoute)
    }
  },
  computed: {
    ...mapFields('directPlacementGoals', ['directPlacementGoals'])
  },
  mounted () {
    this.getDirectPlacementGoals()
  }
}
</script>
